import dayjs from 'dayjs'
import Administered from '../iconsV2/Administered'
import Discontinued from '../iconsV2/Discontinued'
import Missed from '../iconsV2/Missed'
import Paused from '../iconsV2/Paused'
import NotScheduledOrNotNeeded from '../iconsV2/NotScheduledOrNotNeeded'
import { MedicationAction } from '../types'

export const MEDICATION_ACTIONS: MedicationAction[] = [
  {
    icon: <Administered />,
    translationKey: 'ADMINISTERED'
  },
  {
    code: 'VP',
    translationKey: 'VERBAL_PROMPT'
  },
  {
    code: 'A',
    translationKey: 'ABSENT'
  },
  {
    code: 'O',
    translationKey: 'OTHER'
  },
  {
    code: 'AT',
    translationKey: 'ALREADY_TAKEN'
  },
  {
    icon: <NotScheduledOrNotNeeded />,
    translationKey: 'NOT_SCHEDULED_OR_NOT_NEEDED'
  },
  {
    code: 'LO',
    translationKey: 'LEFT_OUT'
  },
  {
    icon: <Paused />,
    translationKey: 'PAUSED'
  },
  {
    code: 'N/V',
    translationKey: 'NAUSEA_OR_VOMITING'
  },
  {
    icon: <Discontinued />,
    translationKey: 'DISCONTINUED'
  },
  {
    code: 'R',
    translationKey: 'REFUSED'
  },
  {
    icon: <Missed />,
    translationKey: 'MISSED'
  },
  {
    code: 'RD',
    translationKey: 'REFUSED_AND_DESTROYED'
  }
]

type MonthDays = {
  month: string
  days: string[]
}

export function generateDatesArray(
  from: dayjs.Dayjs,
  to: dayjs.Dayjs
): MonthDays[] {
  const result: MonthDays[] = []

  let currentDate = from

  while (currentDate.isBefore(to) || currentDate.isSame(to, 'day')) {
    const currentMonthYear = currentDate.format('MM/YY')
    const endOfMonth = currentDate.endOf('month')
    const daysInThisMonth = []

    while (
      (currentDate.isBefore(endOfMonth) ||
        currentDate.isSame(endOfMonth, 'day')) &&
      (currentDate.isBefore(to) || currentDate.isSame(to, 'day'))
    ) {
      daysInThisMonth.push(currentDate.format('DD/MM/YYYY'))
      currentDate = currentDate.add(1, 'day')
    }

    result.push({
      month: currentMonthYear,
      days: daysInThisMonth
    })
  }

  return result
}
